function searchClearFunc() {
	function checkSearchVal() {
		const searchVal = jQuery('.search-field__input').val();
		if (searchVal === '') {
			jQuery('.search .search-field__clear').removeClass('active');
		} else {
			jQuery('.search .search-field__clear').addClass('active');
		}
	}
	checkSearchVal();
	jQuery('.search .search-field__input').keyup(function () {
		checkSearchVal();
	});
	jQuery('.search .search-field__clear').click(function (e) {
		e.preventDefault();
		jQuery('.search-field__input').val('');
		jQuery('.search .search-field__clear').removeClass('active');
	});
}
function searchClear() {
	searchClearFunc();
}
export default searchClear;
